import {
    takeLatest,
    put,
    select,
} from 'redux-saga/effects';

import {
    GET_WEBCHAT_FAILED,
    GET_WEBCHAT_SUCCESS,
} from 'Container/InitWebchat/constants';

import { DISCONNECT_WEBCHAT_SUCCESS} from 'Container/SessionDisconnect/constants';

import {
    trackWebChatError,
    trackWebChatInteraction,
} from 'Container/Tracking/actions';

import {
    TrackingData,
    TrackingDataError,
    TrackingData_Action,
    TrackingData_Variant,
} from 'Container/Tracking/types';
import {
    TRACK_WEBCHAT_AGENT_HANDOVER,
    TRACK_WEBCHAT_DISCONNECT,
    TRACK_WEBCHAT_FAILED,
    TRACK_WEBCHAT_START,
    TRACKING_WEBCHAT_ACTION_DISCONNECT,
    TRACKING_WEBCHAT_ACTION_HANDOVER,
    TRACKING_WEBCHAT_ACTION_START,
    TRACKING_WEBCHAT_VARIANT_OVERLAY,
} from 'Container/Tracking/constants';

import {selectErrorCode} from 'Container/InitWebchat/selector';
import { selectTopic } from 'Container/Ui/selector';
import { HAND_OVER_TO_AGENT } from 'Container/Refresh/constants';

const provideTrackingData = (action: TrackingData_Action, variant: TrackingData_Variant, provider: string) => {
    const trackingData: TrackingData = {
        action,
        variant,
        provider: provider.toLowerCase(),
    };

    return trackingData;
};

/**
 * Tracks, when webchat is started
 */
export function* trackWebChatStartSaga () {
    const provider = yield select(selectTopic());
    const trackingData = provideTrackingData(TRACKING_WEBCHAT_ACTION_START, TRACKING_WEBCHAT_VARIANT_OVERLAY, provider);
    yield put(trackWebChatInteraction(trackingData, TRACK_WEBCHAT_START));
}

/**
 * Tracks, when webchat is started
 */
export function* trackHandoverToAgentSaga () {
    const provider = yield select(selectTopic());
    const trackingData = provideTrackingData(TRACKING_WEBCHAT_ACTION_HANDOVER, TRACKING_WEBCHAT_VARIANT_OVERLAY, provider);
    yield put(trackWebChatInteraction(trackingData, TRACK_WEBCHAT_AGENT_HANDOVER));
}

/**
 * Tracks, when webchat is not started
 */
export function* trackWebChatDisconnectSaga () {
    const provider = yield select(selectTopic());
    const trackingData = provideTrackingData(TRACKING_WEBCHAT_ACTION_DISCONNECT, TRACKING_WEBCHAT_VARIANT_OVERLAY, provider);
    yield put(trackWebChatInteraction(trackingData, TRACK_WEBCHAT_DISCONNECT));
}

/**
 * Tracks, when webchat is not started
 */
export function* trackWebChatStartFailedSaga () {

    const errorCode = yield select(selectErrorCode());
    const trackingData: TrackingDataError = {
        errorCode: errorCode,
        errorMessage: '',
    };

    yield put(trackWebChatError(trackingData, TRACK_WEBCHAT_FAILED));
}

/**
 * Action Dispatcher for tracking actions
 *
 * @export {function} offersSaga
 */
export default function* trackingSaga () {
    yield takeLatest(GET_WEBCHAT_SUCCESS, trackWebChatStartSaga);
    yield takeLatest(GET_WEBCHAT_FAILED, trackWebChatStartFailedSaga);
    yield takeLatest(HAND_OVER_TO_AGENT, trackHandoverToAgentSaga);
    yield takeLatest(DISCONNECT_WEBCHAT_SUCCESS, trackWebChatDisconnectSaga);
}
